define('modules/media/binder',['require','exports','module'],function (require, exports, module) {
	"use strict";

	return module.exports = {
		
		conto: {},
		contoObj: {},

		addEvent: function (obj, type, fn) {
			
			//////console.log ( "OBJ:" , obj.id )
			
			if ((type in this.conto) && (obj.id in this.contoObj)) {

				////console.log ('CE ', type, obj.id);

				return;
			}

			if (obj.attachEvent) {
				obj['e' + type + fn] = fn;
				obj[type + fn] = function () {
					obj['e' + type + fn](window.event);
				};
				obj.attachEvent('on' + type, obj[type + fn]);
			} else {
				obj.addEventListener(type, fn, false);
			}

			this.conto[type] = 1;
			this.contoObj[obj.id] = 1;
		},
		removeEvent: function (obj, type, fn) {

		 //console.log ('ERASE ', type ,obj);

			if (obj.detachEvent) {
				obj.detachEvent('on' + type, obj[type + fn]);
				obj[type + fn] = null;
			} else {
				//////console.log ('ERASE ', type);
				obj.removeEventListener(type, fn, false);
			}

			if (type in this.conto) {
				delete this.conto[type];
			}
			
			if (obj.id in this.contoObj) {
				delete this.contoObj[obj.id];
			}

			//////console.log ('ERASE conto ', this.conto, type);

		}

	};

});
